import { useDripsyTheme } from 'dripsy';

function useThemeColor(key) {
  const { theme } = useDripsyTheme();

  return key.split('.').reduce((obj, k) => obj?.[k], theme?.colors) ?? key;
}

export default useThemeColor;
